import httpModule from '@justeat/f-http';

export default async ({ $statistics, app }, inject) => {
    const getCookieFunction = cookieName => app.$cookies.get(cookieName);

    const genericHttpClient = new httpModule.CreateClient({}, getCookieFunction, $statistics);

    // this.$http.get();
    inject('http', genericHttpClient);
};
